import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';
import { axios } from "../connection/ConnectionHandler";

const formatAttendancerecords = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        exitTime: item.exitTime && moment(item.exitTime),
        entryTime: item.entryTime && moment(item.entryTime),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchAttendancerecords,
    create: createAttendancerecord,
    update: updateAttendancerecord,
    delete: deleteAttendancerecords
} = createCrudActions('ATTENDANCERECORD', "Fichaje", formatAttendancerecords);

export const closeAttendancerecord = (recordId) => async (dispatch) => {
    const response = await axios.put(`ATTENDANCERECORD/${recordId}`, {
        _id: recordId,
        isCheckOut: true,
    });
    const closedRecord = formatAttendancerecords(response.data);

    if (!closedRecord?.exitTime) {
        const error = new Error("La API no confirmó la hora de salida. Inténtalo de nuevo.");
        error.code = "CHECKOUT_NOT_CONFIRMED";
        throw error;
    }

    dispatch({ type: "UPDATE_ATTENDANCERECORD", payload: closedRecord });
    return closedRecord;
};
